import React from "react";
import styled, { keyframes, css } from "styled-components";
import ErrorBoundary from "../ErrorBoundary";

const isActiveAnimation = keyframes`
0% {
  left: 0;
  width: 0%;
}
100% {
  left: 0;
  right: 0;
  width: 100%;
}
`;

const TabLabel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: fit-content;
  padding: 8px 32px;
  cursor: pointer;
  margin-bottom: -16px;
  font-size: 1.2rem;
  font-weight: 500;
  color: ${props =>
    props.isActive ? props.theme.colors.pink400 : props.theme.colors.gray1200};
  &:hover {
    color: ${({ theme }) => theme.colors.pink400};
  }
`;

const TabLabelAnimationBar = styled.div`
  position: absolute;
  transition: width 0.5s ease-in-out;
  height: 2px;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: transparent;
  ${props =>
    props.isActive &&
    css`
      background-color: ${({ theme }) => theme.colors.pink400};
      animation-duration: 0.5s;
      animation-timing-function: ease-in-out;
      animation-name: ${isActiveAnimation};
    `}
`;

const CodeTabLabel = ({ label, isActive, setIsActive }) => {
  return (
    <ErrorBoundary>
      <TabLabel isActive={isActive} onClick={() => setIsActive(label)}>
        {label}
        <TabLabelAnimationBar isActive={isActive} />
      </TabLabel>
    </ErrorBoundary>
  );
};

CodeTabLabel.defaultProps = {
  isActive: false,
  label: "Tab",
  setIsActive: () => null
};

export default CodeTabLabel;
